import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaGamepad, FaCode, FaLaptopCode, FaSearch, FaUserTie, FaCamera, FaTheaterMasks, FaSurprise, FaArrowRight } from 'react-icons/fa';
import '../App.css';

const Events = () => {
  const [currentIndex, setCurrentIndex] = useState(0);


  const events = [
    {
      id: 1,
      title: 'IT Quiz',
      subtitle: 'Test your technical knowledge',
      icon: <FaGamepad className="event-icon" />,
      eventId: 'it-quiz'
    },
    {
      id: 2,
      title: 'Web Designing',
      subtitle: 'Design the web of tomorrow',
      icon: <FaLaptopCode className="event-icon" />,
      eventId: 'web-designing'
    },
    {
      id: 3,
      title: 'Coding and Debugging',
      subtitle: 'Showcase your programming skills',
      icon: <FaCode className="event-icon" />,
      eventId: 'coding'
    },
    {
      id: 4,
      title: 'IT Manager',
      subtitle: 'Test your management skills',
      icon: <FaUserTie className="event-icon" />,
      eventId: 'it-manager'
    },
    {
      id: 5,
      title: 'Photography and Videography',
      subtitle: 'Capture the perfect moment',
      icon: <FaCamera className="event-icon" />,
      eventId: 'photography'
    },
    {
      id: 6,
      title: 'Surprise Event',
      subtitle: 'Expect the unexpected',
      icon: <FaSurprise className="event-icon" />,
      eventId: 'surprise-event'
    },
    {
      id: 7,
      title: 'Quick Shot',
      subtitle: 'Tell your story',
      icon: <FaTheaterMasks className="event-icon" />,
      eventId: 'quick-shot'
    },
    {
      id: 8,
      title: 'Treasure Hunt',
      subtitle: 'Solve clues, find treasures',
      icon: <FaSearch className="event-icon" />,
      eventId: 'treasure-hunt'
    },
    {
      id: 9,
      title: 'Tech Charades',
      subtitle: 'Act it out',
      icon: <FaTheaterMasks className="event-icon" />,
      eventId: 'tech-charades'
    },
    {
      id: 10,
      title: 'Gaming',
      subtitle: 'Battle it out',
      icon: <FaGamepad className="event-icon" />,
      eventId: 'bgmi'
    },
    {
      id: 11,
      title: 'Dance Competition',
      subtitle: 'Show your moves',
      icon: <FaTheaterMasks className="event-icon" />,
      eventId: 'dance'
    }
  ];

 // Update the scrollToCard function to fix the ESLint error
  const scrollToCard = (index) => {
    if (window.innerWidth < 768) return; // Only for desktop
    
    // Force reflow before starting animation
    const slider = document.querySelector('.events-slider');
    if (!slider) return;
    
    // Use requestAnimationFrame for smooth animation
    requestAnimationFrame(() => {
      // Ensure the DOM has updated with new classes
      requestAnimationFrame(() => {
        const cards = document.querySelectorAll('.event-card');
        if (cards[index]) {
          // Trigger reflow to ensure smooth animation
          void cards[index].offsetHeight;
        }
      });
    });
  };

  const nextSlide = () => {
    setCurrentIndex(prev => {
      const newIndex = (prev + 1) % events.length;
      // Small delay to ensure state is updated before scrolling
      setTimeout(() => scrollToCard(newIndex), 10);
      return newIndex;
    });
  };

  const prevSlide = () => {
    setCurrentIndex(prev => {
      const newIndex = (prev - 1 + events.length) % events.length;
      // Small delay to ensure state is updated before scrolling
      setTimeout(() => scrollToCard(newIndex), 10);
      return newIndex;
    });
  };

  // Function to handle scroll events for mobile
  const handleScroll = (e) => {
    const container = e.target;
    const scrollPosition = container.scrollLeft + container.offsetWidth / 2;
    const cards = container.querySelectorAll('.event-card');
    
    cards.forEach((card, index) => {
      const cardPosition = card.offsetLeft + card.offsetWidth / 2;
      if (Math.abs(scrollPosition - cardPosition) < card.offsetWidth / 2) {
        setCurrentIndex(index);
      }
    });
  };

  // For desktop, show current, previous and next cards
  const getVisibleEvents = () => {
    if (window.innerWidth >= 768) { // Desktop
      return [
        events[(currentIndex - 1 + events.length) % events.length],
        events[currentIndex],
        events[(currentIndex + 1) % events.length]
      ];
    }
    return events; // Mobile - show all cards for scrolling
  };

  const visibleEvents = getVisibleEvents();

  return (
    <section id="events" className="py-3">
      <div className="container">
        <div className="section-header text-center mb-1">
          <h2 className="section-title">Our Events</h2>
        </div>
        <div className="events-container">
          <button className="nav-arrow left-arrow d-none d-md-flex" onClick={prevSlide} aria-label="Previous event">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>
          
          <div 
            className="events-slider"
            onScroll={window.innerWidth < 768 ? handleScroll : undefined}
            style={{
              scrollSnapType: window.innerWidth < 768 ? 'x mandatory' : 'none',
              WebkitOverflowScrolling: 'touch',
              msOverflowStyle: 'none',
              scrollbarWidth: 'none',
              justifyContent: window.innerWidth >= 768 ? 'center' : 'flex-start'
            }}
          >
            {visibleEvents.map((event, index) => {
              const isActive = window.innerWidth >= 768 
                ? index === 1 // Center card is active on desktop
                : event.id === events[currentIndex].id; // Current index card on mobile
              const position = window.innerWidth >= 768 
                ? index === 0 ? 'left' : index === 1 ? 'center' : 'right'
                : 'mobile';
              const isMobile = window.innerWidth < 768;
              return (
                <div 
                  key={event.id} 
                  className={`event-card ${position} ${isActive ? 'active' : ''}`}
                  style={{
                    transform: isMobile 
                      ? isActive ? 'scale(1)' : 'scale(0.9)'
                      : position === 'center' ? 'scale(1)' : 'scale(0.85)',
                    opacity: isActive ? 1 : 0.6,
                    transition: 'transform 0.3s ease, opacity 0.3s ease',
                    scrollSnapAlign: isMobile ? 'center' : 'none',
                    flex: '0 0 auto',
                    width: isMobile ? '85%' : '350px',
                    margin: isMobile ? '0 10px' : '0 -40px',
                    position: isMobile ? 'relative' : 'static',
                    zIndex: position === 'center' ? 2 : 1
                  }}
                  onClick={() => {
                    const newIndex = events.findIndex(e => e.id === event.id);
                    setCurrentIndex(newIndex);
                    if (window.innerWidth >= 768) {
                      scrollToCard(newIndex);
                    }
                  }}
                >
                  <div className="event-image" style={{ 
                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/events/${event.eventId}.png)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundColor: isActive ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.5)'
                  }}>
                    <div className="event-overlay" style={{
                      background: 'linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))',
                      cursor: isActive ? 'pointer' : 'not-allowed'
                    }}>
                      <div className="event-icon-container">
                        {event.icon}
                      </div>
                      <h3>{event.title}</h3>
                      <p>{event.subtitle}</p>
                      <div className="d-flex justify-content-center">
                        <Link 
                          to={`/events/${event.eventId}`}
                          className={`btn mt-3 d-flex align-items-center ${isActive ? 'btn-warning' : 'btn-secondary'}`}
                          style={{
                            opacity: isActive ? 1 : 0.7,
                            pointerEvents: isActive ? 'auto' : 'none',
                            textDecoration: 'none',
                            color: isActive ? '#000' : '#fff'
                          }}
                        >
                          View Details <FaArrowRight className="ms-2" style={{ marginTop: '1px' }} />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          
          <button className="nav-arrow right-arrow d-none d-md-flex" onClick={nextSlide} aria-label="Next event">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
        
        {/* Mobile scroll indicator */}
        <div className="d-md-none text-center">
          <div className="text-white-60">
            <i className="bi bi-arrow-left-right me-2"></i>
            Scroll to view more
          </div>
        </div>
        
        {/* Dots for mobile */}
        <div className="dots-container d-md-none">
          {events.map((_, index) => (
            <span 
              key={index} 
              className={`dot ${currentIndex === index ? 'active' : ''}`}
              onClick={() => {
                setCurrentIndex(index);
                scrollToCard(index);
              }}
            />
          ))}
        </div>
        
        <div className="event-dots">
          {events.map((_, index) => (
            <span 
              key={index} 
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => {
                setCurrentIndex(index);
                // Scroll the slider to the selected card
                const slider = document.querySelector('.events-slider');
                const card = document.querySelectorAll('.event-card')[index];
                if (slider && card) {
                  slider.scrollTo({
                    left: card.offsetLeft - (slider.offsetWidth - card.offsetWidth) / 2,
                    behavior: 'smooth'
                  });
                }
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;
